import { apiClient } from "../apiClient";

const KE_HOAC_THUC_TAP_PHAM_VI_ENDPOINT = 'ke-hoach-thuc-tap-pham-vi';
export const keHoachThucTapPhamViApi = {
    SelectByDotThucTap: (id_dot_thuc_tap: number) => apiClient.get(`${KE_HOAC_THUC_TAP_PHAM_VI_ENDPOINT}/dot-thuc-tap/${id_dot_thuc_tap}`),
    Insert: (data: any) => apiClient.post(`${KE_HOAC_THUC_TAP_PHAM_VI_ENDPOINT}`, data),
    Delete: (id: number) => apiClient.delete(`${KE_HOAC_THUC_TAP_PHAM_VI_ENDPOINT}/${id}`),
}